import React from 'react';

function CloseIcon(props: React.HTMLAttributes<SVGElement>) {
  return (
    <svg width="44" height="44" viewBox="0 0 768 768" {...props}>
      <path d="M607.5 205.5l-178.5 178.5 178.5 178.5-45 45-178.5-178.5-178.5 178.5-45-45 178.5-178.5-178.5-178.5 45-45 178.5 178.5 178.5-178.5z" />
    </svg>
  );
}

export default CloseIcon;
